import { h, Component } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import Hero from 'components/pages/hub/hero';
import Tiles from 'components/pages/hub/tiles';
import Signup from 'components/pages/hub/signup';
import s from 'components/pages/hub/hub.sss';

export default class Hub extends Component {
	render({ pageData, client }, state) {
		const {
			sections: sectionData = {}
		} = pageData;

		const sections = sortObjectByOrder(sectionData);

		return (
			<main>
				<div class={s.container}>
					{sections.map(section => {
						const { type = '' } = section;
						let content;

						switch(type) {
							case 'hero':
								content = <Hero data={section} client={client} />;
								break;
							case 'tiles':
								content = <Tiles data={section} client={client} />;
								break;
							case 'signup':
								content = <Signup data={section} client={client} />;
								break;
							default:
								break;
						}

						return content;
					})}
				</div>
			</main>
		);
	}
}
